<template>
  <div class="partnershipIconsContainer">
    <Beckett v-if="type === 'beckett'" :fill="fill" :height="height" :width="width"/>
    <Cgc v-else-if="type === 'cgc'" :fill="fill" :height="height" :width="width"/>
    <Sgc v-else-if="type === 'sgc'" :fill="fill" :height="height" :width="width"/>
    <PSALogo v-else-if="type === 'psa'" :fill="fill" :fillS="fill" :height="height" :width="width"/>
  </div>
</template>

<script>
import { Beckett, Cgc, Sgc, PSALogo } from '@js/web/components/icons';
export default {
  name: 'PartnershipIcons',
  components: {
    Beckett,
    Cgc,
    Sgc,
    PSALogo
  },
  props: {
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
    height: {
      type: String,
      required: false,
      default: '16px'
    },
    width: {
      type: String,
      required: false,
      default: '16px'
    },
    type: {
      type: String,
      required: true
    }
  }
};
</script>
